import { render } from "./EsgForm.vue?vue&type=template&id=edba6a76"
import script from "./EsgForm.vue?vue&type=script&lang=js"
export * from "./EsgForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__